import { PageHero } from "@/components/PublicLayout";
import { COMPANY } from "@/lib/data";

const CONTENT = {
  "privacy-policy": {
    title: "Privacy Policy",
    intro: "CareDeserved LLC respects your privacy. This policy explains how we handle the information you share with us.",
    sections: [
      ["Information We Collect", "We collect information you voluntarily provide through our forms, such as your name, contact details, pickup and destination addresses, and transportation preferences, so we can arrange and confirm transportation."],
      ["How We Use Your Information", "Your information is used solely to coordinate transportation, respond to inquiries, process applications, and improve our services. We do not sell your personal information."],
      ["Protecting Sensitive Information", "We do not publicly display sensitive medical information. Details you submit are stored securely and are accessible only to authorized CareDeserved staff."],
      ["Contact", `Questions about this policy? Email ${COMPANY.email} or call ${COMPANY.phone}.`],
    ],
  },
  "terms-of-use": {
    title: "Terms of Use",
    intro: "By using the CareDeserved website, you agree to the following terms.",
    sections: [
      ["Service Requests", "Submitting a form on this website does not guarantee transportation. A CareDeserved representative will confirm availability before any trip is scheduled."],
      ["Accuracy of Information", "You agree to provide accurate information when requesting transportation or applying for employment."],
      ["Website Content", "Content on this site is provided for general information and may be updated at any time without notice."],
      ["Contact", `Questions about these terms? Email ${COMPANY.email} or call ${COMPANY.phone}.`],
    ],
  },
  "accessibility": {
    title: "Accessibility",
    intro: "CareDeserved is committed to making our services and website accessible to everyone.",
    sections: [
      ["Our Commitment", "We strive to provide transportation and digital experiences that are usable by people of all abilities, including passengers who use wheelchairs or require additional assistance."],
      ["Website Accessibility", "We aim to follow recognized accessibility best practices, including readable text, strong color contrast, keyboard-friendly navigation, and descriptive labels."],
      ["Need Assistance?", `If you experience any difficulty using this website or need help arranging transportation, please call us at ${COMPANY.phone} and we'll be glad to assist.`],
    ],
  },
};

export default function Legal({ page }) {
  const data = CONTENT[page] || CONTENT["privacy-policy"];
  return (
    <>
      <PageHero eyebrow="Legal" title={data.title} subtitle={data.intro} />
      <section className="bg-white py-20 sm:py-28">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 space-y-10">
          {data.sections.map(([h, p]) => (
            <div key={h}>
              <h2 className="font-heading text-xl font-semibold text-slate-900">{h}</h2>
              <p className="mt-3 leading-relaxed text-slate-600">{p}</p>
            </div>
          ))}
          <p className="text-sm text-slate-400">Last updated {new Date().getFullYear()}.</p>
        </div>
      </section>
    </>
  );
}
